import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Form, Input, Row} from "antd";
import {FileUploader} from "../../components/fileUploader/fileUploader";
import {userService} from "../../services/user.service";
import {useSelector} from "react-redux";
import {ConvertBlogToFile} from "../../utils/ProfileFunctions";

export const FormUserAvatar = ({handleNextStatus,handleUpdateProfile,profileInfo}) => {
    const [user, setUser] = useState({
        nickname: "",
        urlProfileImage: "",
    });
    const [form] = Form.useForm();
    const [isUserFromGoogle,setIsUserFromGoogle] = useState(true);
    const companyId = useSelector((state) => state.userSettings.companyId);
    const [alert,setAlert] = useState({title: "", description: "",show: false});
    const [file,setFile] = useState("");

    const handleSaveStep = () => localStorage.setItem("stepContentComplete", JSON.stringify({ isComplete: true }));

    const onSubmit = async () => {
        try {
            if(!(isUserFromGoogle) || (isUserFromGoogle && user.nickname !== "")) {
                const result = await userService.editProfile(user,companyId);
                if(!result.success)
                    handleShowAlert("Hubo un problema".result.msg,true);
            }
        } catch (error) {
            console.error('Error en el registro:', error);
        }
        handleSaveStep();
        handleNextStatus("default",3);
        handleUpdateProfile();
    };

    const handleShowAlert = (title,description,status) => setAlert({title: title,description: description, show: status})

    const handleInputValue = (e) =>
        setUser({ ...user, [e.target.name]: e.target.value });

    const handleFileSelected = (file) => {
        form.setFieldValue("urlProfileImage",file);
        setUser({ ...user, urlProfileImage:file });
    }

    const handleFileRemoved = (file) => {
        form.resetFields(['urlProfileImage']);
        setUser({ ...user, urlProfileImage:file });
        setFile("");
    }

    const handleLoadImage = async () => {
        const fileConverted = await ConvertBlogToFile(profileInfo?.urlProfileImage);
        setFile(fileConverted)
    }

    useEffect(() => {
        if(profileInfo.loginProvider !== 3)
            setIsUserFromGoogle(false)

        if(profileInfo?.urlProfileImage !== process.env.REACT_APP_AVATAR_URL) {
            handleLoadImage();
        }

        form.setFieldsValue({ nickname: profileInfo.nickname });
        setUser({ ...user, nickname: profileInfo.nickname });
    }, [profileInfo]);

    return (
        <article className="profile__form">
            <Form
                form={form}
                className={"form-light"}
                onFinish={onSubmit}
                layout={"vertical"}
            >
                <Row gutter={[0,8]}>
                    <Col xs={24}>
                        <div className={"form-light__title"}>
                            <h4>Configura tu perfil</h4>
                            <p>Sube tu foto</p>
                            <small className={"text-required"}>Los campos con <span>*</span> son obligatorios</small>
                        </div>
                    </Col>
                    {
                        (alert.show) && (
                            <Col xs={24}>
                                <Alert
                                    message={alert.title}
                                    description={alert.msg}
                                    type="warning"
                                    showIcon
                                    closable
                                />
                            </Col>
                        )
                    }
                    <Col xs={24}>
                        <Form.Item
                            label={"Nickname"}
                            name={"nickname"}
                            htmlFor={"nickname"}
                            onChange={handleInputValue}
                        >
                            <Input name={"nickname"} size={"large"} placeholder={"¿Tienes un apodo?"} />
                        </Form.Item>
                    </Col>
                    {

                        (!isUserFromGoogle) ?
                            <Col xs={24}>
                                <Form.Item
                                    label={"Sube tu foto de perfil"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "*Campo requerido",
                                        },
                                    ]}
                                    name={"urlProfileImage"}
                                    htmlFor={"urlProfileImage"}
                                >
                                    <FileUploader
                                        onFilesSelected={handleFileSelected}
                                        fieldName={"urlProfileImage"}
                                        onDeleteFiles={handleFileRemoved}
                                        updateFiles={(file !== "") ? [file] : []}
                                        acceptFiles={["image/png", "image/jpeg", "image/webp", "image/jpg"]}
                                    />
                                </Form.Item>
                            </Col>
                            :
                            <Col xs={24}>
                                <Form.Item
                                    label={"Sube tu foto de perfil"}
                                >
                                    <Alert
                                        type={"info"}
                                        showIcon={true}
                                        message={"¡Ups!"}
                                        closable={true}
                                        description={"No puedes subir otra foto de perfil porque creaste tu cuenta con un proveedor externo."}
                                    />
                                </Form.Item>
                            </Col>
                    }
                </Row>
                <div className={"form-light__footer"}>
                    <Button
                        htmlType={"button"}
                        type={"default"}
                        block={true}
                        onClick={() => handleNextStatus("default",2)}
                    >
                        Regresar
                    </Button>
                    <Button
                        htmlType={"submit"}
                        type={"primary"}
                        block={true}
                    >
                        Guardar
                    </Button>
                </div>
            </Form>
        </article>
    );
}